/**
 * Tabbed Product Component
 * Handles tab switching and video modal functionality
 */

class TabbedCollection extends HTMLElement {
  constructor() {
    super();
    this.modal = document.getElementById(`VideoModal-${this.dataset.sectionId}`);
    this.modalVideo = this.modal ? this.modal.querySelector('video') : null;
    this.modalClose = this.modal ? this.modal.querySelector('.tabbed-collection__modal-close') : null;
  }

  connectedCallback() {
    this.init();
    this.initVideoModal();
  }

  init() {
    this.tabs = this.querySelectorAll('.tabbed-collection__tab');
    this.panels = this.querySelectorAll('.tabbed-collection__panel');

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.switchTab(index));
    });
  }

  switchTab(index) {
    // Remove active class from all tabs and panels
    this.tabs.forEach(tab => {
      tab.classList.remove('active');
      tab.setAttribute('aria-selected', 'false');
    });
    this.panels.forEach(panel => panel.classList.remove('active'));

    // Add active class to selected tab and panel
    this.tabs[index].classList.add('active');
    this.tabs[index].setAttribute('aria-selected', 'true');
    this.panels[index].classList.add('active');
  }

  initVideoModal() {
    if (!this.modal || !this.modalVideo) return;

    // Listen for play button clicks
    this.addEventListener('click', (event) => {
      const playButton = event.target.closest('.tabbed-collection__video-play');
      if (playButton) {
        const videoUrl = playButton.dataset.videoUrl;
        if (videoUrl) {
          this.openModal(videoUrl);
        }
      }
    });

    // Close modal on close button click
    if (this.modalClose) {
      this.modalClose.addEventListener('click', () => this.closeModal());
    }

    // Close modal on background click
    this.modal.addEventListener('click', (event) => {
      if (event.target === this.modal) {
        this.closeModal();
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.modal.classList.contains('active')) {
        this.closeModal();
      }
    });
  }

  openModal(url) {
    this.modalVideo.src = url;
    this.modal.classList.add('active');
    this.modalVideo.play();
    document.body.style.overflow = 'hidden'; // Prevent scrolling
  }

  closeModal() {
    this.modal.classList.remove('active');
    this.modalVideo.pause();
    this.modalVideo.src = '';
    document.body.style.overflow = ''; // Restore scrolling
  }
}

if (!customElements.get('tabbed-collection')) {
  customElements.define('tabbed-collection', TabbedCollection);
}

// Section reload support for Shopify theme editor
document.addEventListener('shopify:section:load', function(event) {
  const tabbedCollections = event.target.querySelectorAll('tabbed-collection');
  tabbedCollections.forEach(element => {
    element.init();
    element.initVideoModal();
  });
});
